import { Transform, Type } from "class-transformer";

export const TransformToDateWithoutTime = (
  target: any,
  propertyKey: string
) => {
  Type(() => Date)(target, propertyKey);
  Transform((value) => {
    if (!value) {
      return undefined;
    }
    const d = new Date(value);
    // We want to lose all time information, so we set the time to 00:00:00
    return new Date(
      Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
    );
  })(target, propertyKey);
};
